import React, { useState } from 'react';

import { twMerge } from 'tailwind-merge';

import { useNavigate } from 'react-router-dom';

import Typography from 'components-new/typography/typography';
import Button from 'components-new/button/button';

import { createLocale } from 'locales';
import Divider from 'components-new/divider/divider';

const localize = createLocale('freelancerAvailableJobsLocales');

interface headingPropTypes {
  leftBtnActive: boolean;
  title?: string;
  containerClassName?: string;
}

const Heading: React.FC<headingPropTypes> = (props) => {
  const navigate = useNavigate();

  const { title, leftBtnActive, containerClassName } = props;
  const [leftButtonAcive, setLeftButtonActive] = useState(leftBtnActive);
  const buttonActiveClassName = twMerge(
    'bg-lightBlue text-white hover:bg-darkBlue',
    'flex w-fit px-3  h-10 justify-center  items-center',
    'border-gray300',
  );
  const buttonDefaultClassName = twMerge(
    'bg-white text-gray900 hover:bg-gray100',
    'flex w-fit px-3  h-10 justify-center  items-center',
    'border-gray300',
  );

  const messageClassName = twMerge(
    'container flex flex-col justify-start w-full mb-10 px-3 md:px-0',
    containerClassName,
  );

  const defaultBtnTextColor = 'text-body-small mx-2';

  let leftButtonClassName = '';
  let righButtonClassName = '';
  let leftButtonTextColor = '';
  let rightbuttonTextColor = '';

  if (leftButtonAcive) {
    leftButtonClassName = buttonActiveClassName.concat(
      ' rounded-r-none border-r-0',
    );
    leftButtonTextColor = defaultBtnTextColor.concat(' text-gray100');
    righButtonClassName = buttonDefaultClassName.concat(
      ' rounded-l-none border-l-0',
    );
    rightbuttonTextColor = defaultBtnTextColor.concat(' text-gray900');
  } else {
    leftButtonClassName = buttonDefaultClassName.concat(
      ' rounded-r-none border-r-0',
    );
    righButtonClassName = buttonActiveClassName.concat(
      ' rounded-l-none border-l-0',
    );
    leftButtonTextColor = defaultBtnTextColor.concat(' text-gray900');
    rightbuttonTextColor = defaultBtnTextColor.concat(' text-gray100');
  }

  return (
    <div className={messageClassName}>
      <Typography variant="heading-1" as="h1" className="text-primary-400 mb-5">
        {title}
      </Typography>
      <Divider orientation="horizontal" />
      <div className="h-1 rounded-lg  w-full mt-2 mb-6" />
      <div className="container flex items-center justify-center px-0 mx-0 text-background">
        <Button
          variant="secondary"
          label={localize('longerAssignments')}
          className={leftButtonClassName}
          labelClassName={leftButtonTextColor}
          onClick={() => {
            setLeftButtonActive(true);
            navigate('/freelancer/ads/period/');
          }}
        />
        <Button
          variant="secondary"
          label={localize('singleCalls')}
          className={righButtonClassName}
          labelClassName={rightbuttonTextColor}
          onClick={() => {
            setLeftButtonActive(false);
            navigate('/freelancer/ads/all/');
          }}
        />
      </div>
    </div>
  );
};

export default Heading;
